import Vue from "vue";
import CookieHelper from "@/helpers/CookieHelper";

const state = {};

const actions = {
  login(context, payload) {
    return Vue.prototype.$login_http.post("/api/login-check", payload);
  },
  register(context, payload) {
    return Vue.prototype.$http.post("/api/users/v1/register", payload);
  },
  async facebookLogin(context, payload) {
    try {
      await Vue.prototype.$http.post("/api/login/v1/facebook", payload);
    } catch (e) {
      return false;
    }
    return true;
  },
  async facebookConnect(context, payload) {
    return await Vue.prototype.$http.post("/api/facebook/v1/connect", payload);
  },
  user() {
    return Vue.prototype.$http.get("/api/users/v1");
  },

  update(context, payload) {
    return Vue.prototype.$http.put("/api/users/v1", payload);
  },
  delete() {
    return Vue.prototype.$http.delete("/api/users/v1");
  },
  addAnonymousCard(context, payload) {
    return Vue.prototype.$http
      .post("/api/anonymous-cards/v1", payload)
      .then(response => {
        context.state.anonymous_cards.push(response.data);
      });
  },
  deleteAnonymousCard(context, payload) {
    return Vue.prototype.$http
      .delete("/api/anonymous-cards/v1/" + payload.barcode, payload)
      .then(() => {
        context.state.anonymous_cards.splice(
          context.state.anonymous_cards.findIndex(item => {
            return item.barcode === payload.barcode;
          }),
          1
        );
      });
  },
  validateBarcode(context, payload) {
    return Vue.prototype.$http.get(
      "/api/registration/v1/validate-barcode/" +
        payload.type +
        "/" +
        payload.value
    );
  },
  validateEmail(context, payload) {
    return Vue.prototype.$http.post(
      "/api/registration/v1/validate-email",
      payload
    );
  },
  validateLicensePlate(context, payload) {
    return Vue.prototype.$http.post(
      "/api/registration/v1/validate-license-plate",
      payload
    );
  },
  getDataForUnsubscribe(context, payload) {
    return Vue.prototype.$http.get(
      "/api/unsubscribe/v1/" + payload.token,
      payload
    );
  },
  putUnsubscribeData(context, payload) {
    return Vue.prototype.$http.put(
      "/api/unsubscribe/v1/" + payload.token,
      payload.data
    );
  },
  resetPasswordRequest(context, payload) {
    return Vue.prototype.$http.post(
      "/api/resetting/v1/reset-password-request",
      payload
    );
  },
  resetPassword(context, payload) {
    return Vue.prototype.$http.post(
      "/api/resetting/v1/reset-password/" + payload.reset_token,
      {
        password: payload.password
      }
    );
  },
  getToken(context, payload) {
    return Vue.prototype.$http.post("/api/finish-login", payload);
  },
  validateResetPasswordToken(context, payload) {
    return Vue.prototype.$http.get(
      "/api/resetting/v1/validate-reset-password-token/" + payload
    );
  },
  confirmRegistration(context, payload) {
    return Vue.prototype.$http.get(
      "/api/registration/v1/confirm-registration/" + payload
    );
  }
};

const mutations = {
  user(state, payload) {
    Object.keys(payload).forEach(key => {
      state[key] = payload[key];
    });
  },
  setFromCookie(state) {
    let cookie = CookieHelper.getUserCookie();
    Object.keys(cookie).forEach(key => {
      state[key] = cookie[key];
    });
  }
};

const getters = {
  user: state => {
    return state;
  }
};

export const user = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
